import { JSX } from "react";
import "rc-slider/assets/index.css";
import { lazy, Suspense, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";
import api from "./api";
import { getPublicAppOptions } from "./apiPublic";
import LoadingIndicator from "./Components/LoadingIndicatorV2";
import PrintDisclaimer from "./Components/PrintDisclaimer";
import { AppOptions } from "./types";

const ExternalRouter = lazy(() => import("./Routes/ExternalRouter"));
const InternalRouter = lazy(() => import("./Routes/InternalRouter"));

export function getBrowserBaseURL() {
  return window.location.origin;
}

export const loading: JSX.Element = (
  <div className="flex flex-col h-screen justify-center">
    <LoadingIndicator fullScreen />
  </div>
);

function App() {
  const location = useLocation();
  const [appOptions, setAppOptions] = useState<undefined | AppOptions>();
  const [spacLoading, setSpacLoading] = useState<boolean>(true);
  const isLarge = useMediaQuery({ minDeviceWidth: 768 });
  const authenticated: boolean = !!localStorage.authToken;

  useEffect(() => {
    async function fetchAppOptions() {
      const res = authenticated
        ? await api.getAppOptions()
        : await getPublicAppOptions();
      setAppOptions(res.data);
    }
    fetchAppOptions();
  }, [authenticated]);

  return (
    <Suspense fallback={loading}>
      {authenticated ? (
        <InternalRouter
          appOptions={appOptions}
          isLarge={isLarge}
          spacLoading={spacLoading}
          setSpacLoading={setSpacLoading}
        />
      ) : (
        <ExternalRouter
          appOptions={appOptions}
          isLarge={isLarge}
          spacLoading={spacLoading}
          setSpacLoading={setSpacLoading}
        />
      )}
      <PrintDisclaimer />
    </Suspense>
  );
}

export default App;
